export const emptyDepositEstimate = () => ({
  components: [],
  amount: 0,
  currency: null,
  complete: true,
});

export const normalizeDepositEstimate = (estimate) => ({
  components: Array.isArray(estimate?.components) ? estimate.components : [],
  amount: parseFloat(estimate?.amount) || 0,
  currency: estimate?.currency || null,
  complete: typeof estimate?.complete === "boolean" ? estimate.complete : true,
});

export const normalizeSupplierOrderUnit = (orderUnit) => {
  if (!orderUnit) {
    return null;
  }

  const depositEstimate = normalizeDepositEstimate(orderUnit.deposit_estimate);

  return {
    ...orderUnit,
    deposit_components: Array.isArray(orderUnit.deposit_components)
      ? orderUnit.deposit_components
      : depositEstimate.components,
    deposit_estimate: depositEstimate,
  };
};

export const normalizeSupplierOrderCartItem = (item = {}) => {
  const orderUnit = normalizeSupplierOrderUnit(item.orderUnit);
  const depositEstimate = normalizeDepositEstimate(
    item.depositEstimate ?? item.deposit_estimate ?? orderUnit?.deposit_estimate
  );

  return {
    ...item,
    orderUnitId: item.orderUnitId ?? item.order_unit_id ?? orderUnit?.id ?? null,
    orderUnit,
    depositEstimate,
  };
};

export const purchaseConditionsFingerprint = (unit, price, estimate) => JSON.stringify({
  unit: unit ? [unit.id, unit.code, Number(unit.base_product_quantity)] : null,
  price: price ? [price.id ?? null, Number(price.amount), price.currency, Number(price.tax || 0)] : null,
  deposit: normalizeDepositEstimate(estimate),
});

export const getActiveSupplierOrderUnits = (units = []) => units.filter(unit =>
  unit.active !== false && unit.active !== 0 && unit.active !== '0'
);

export const getDefaultSupplierOrderUnit = (supplier) => {
  const orderUnits = getActiveSupplierOrderUnits(supplier?.order_units || []);
  const orderUnit = orderUnits.find(
    (unit) => Number(unit.id) === Number(supplier?.default_order_unit_id)
  ) || orderUnits.find((unit) => unit.is_default) || orderUnits[0] || null;

  return normalizeSupplierOrderUnit(orderUnit);
};
